import { useState } from "react";
import {
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
    Link,
    Grid,
    Box,
    Typography,
    Container,
    CssBaseline,
    Paper,
    InputAdornment,
    IconButton,

} from "@mui/material";
import { postApiSignInVenue } from "../../../Core/Apicall";
import Icons from "../../../Constants/Icons";
import { useDispatch } from "react-redux";
import { setProfileData } from "../../../Config/Actions/profileActions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function Login() {


    const [formData, setFormData] = useState({
        email: "",
        password: "",
        remember: false,
    });
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate()
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const dispatch = useDispatch();
    const getDeviceType = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(ua)) return "Android";
        if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "IOS";
        if (/Windows NT|Macintosh|Linux|CrOS/i.test(ua)) return "Web"; // Desktop browsers
        return "Other";
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = {
                emailId: formData.email,
                password: formData.password,
                deviceType: getDeviceType()
            };
            const res = await postApiSignInVenue(data);

            toast.success(res.message || "Login successful");
            navigate("/dashboard")

            dispatch(setProfileData(res));
        } catch (error) {
            toast.error(error || "Something went wrong. Please try again later.");
        }
    };
    const handleClickShowPassword = () => setShowPassword(!showPassword);

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Paper
                elevation={6}
                sx={{
                    p: 4,
                    mt: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <img src={Icons.Ic_logo} alt="louca_logo" />
                <Typography component="h1" variant="h5">
                    Login
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type={showPassword ? "text" : "password"} // dynamic
                        id="password"
                        autoComplete="current-password"
                        value={formData.password}
                        onChange={handleChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                name="remember"
                                checked={formData.remember}
                                onChange={handleChange}
                                color="primary"
                            />
                        }
                        label="Remember me"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, backgroundColor: "black" }}
                    >
                        Sign In
                    </Button>
                    <Grid container>
                        <Grid size={12}>
                            <Link
                                href="/ForgotPassword"
                                style={{ color: "black", textDecoration: "none" }}
                                variant="body2"
                            >
                                Forgot password?
                            </Link>
                        </Grid>
                        <Grid size={12} style={{ textAlign: "right", marginTop: "10px" }}>
                            <Typography variant="body2" style={{ cursor: "pointer" }}>
                                Don't have an account?{" "}
                                <Link
                                    onClick={() => navigate("/register")}

                                    style={{ color: "black", textDecoration: "none" }}
                                >
                                    Register
                                </Link>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Container>
    );
}
